// extracted by mini-css-extract-plugin
export default {"cart-accordion-summary":"styles_cart-accordion-summary__fwcRO","fullView":"styles_fullView__t+8G6","shimmer":"styles_shimmer__4uRf4"};